import React from 'react';
import { appContext } from '../components/appContext';

// In separate file so it can be mocked in tests
export function useCurrentAppContext() {
    return React.useContext(appContext.context);
}
